// extracted by mini-css-extract-plugin
module.exports = {"colors":"'~css/colors.css'","_gray-light":"#eaeaea","_gray-darker":"#333333","resourceRow":"Resources_resourceRow__2yWm7","resourceName":"Resources_resourceName__2jmbe"};